<template>
  <el-dialog
    :visible.sync="isVisible"
    title="会员课时转让页面"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :rules="form_rules"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <el-form-item label="转出课时数">
          <el-input
            type="text"
            placeholder="请输入课时数"
            v-model="form.classhours"
          ></el-input>
        </el-form-item>
        <el-form-item label="转入手机号">
          <el-input
            type="text"
            placeholder="请输入手机号"
            v-model="form.inTelephone"
          ></el-input>
        </el-form-item>
        <!--课时类型-->
        <el-form-item label="转入课包类型">
          <el-cascader
            v-model="form.inCoursePackageId"
            :options="options"
            collapse-tags
            :show-all-levels="false"
            clearable
          ></el-cascader>
          <!-- <el-select
            v-model="form.inCoursePackageId"
            placeholder="请选择课时类型"
          >
            <el-option
              v-for="item in this.coursePackageList.coursePackageList"
              :key="item.text"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select> -->
        </el-form-item>

        <el-form-item label="转入课包截止时间">
          <el-date-picker
            v-model="form.coursePackageDDL"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item class="text_right">
          <el-button @click="isVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table max-height="200" :data="tableData" style="width: 100%">
        <el-table-column prop="transferDate" label="日期" width="180">
        </el-table-column>
        <el-table-column prop="packageName" label="转出课包名称" width="180">
        </el-table-column>
        <el-table-column prop="classhours" label="转出课时数">
        </el-table-column>
        <el-table-column prop="inTelephoneNumber" label="转入用户手机号">
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {
  transferClassHour,
  getClassHourTransferRecordByTelephoneNumber,
} from "@/api/classhourspend";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";
import { getFormatCoursePackagesForCourse } from "@/api/coursepackage";

export default {
  name: "addFundDialogs",
  data() {
    let validateClassHour = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("课时增加/减少不能为空"));
      } else {
        var reg = /^\+|-/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的格式(+1|-1)"));
        } else {
          callback();
        }
      }
    };
    return {
      props: { emitPath: false },
      options: [],
      tableData: [],
      isVisible: this.isShow,
      selectDisabled: false,
      form: {
        coursePackageAndMemberId: "",
        outTelephone: "",
        outCoursePackageId: "",
        classhours: "",
        inTelephone: "",
        inCoursePackageId: "",
        coursePackageDDL: "",
      },
      form_rules: {
        type: [
          { required: true, message: "自定义条目不能为空", trigger: "blur" },
        ],
        classhourType: [
          { required: true, message: "课时类型不能为空", trigger: "blur" },
        ],
        classhours: [
          { required: true, message: "课时增加/减少不能为空", trigger: "blur" },
          { validator: validateClassHour },
        ],
        opreateDate: [
          { required: true, message: "日期不能为空", trigger: "blur" },
        ],
      },
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
    };
  },
  props: {
    dialogRow: Object,
    isShow: Boolean,
    username: String,
    telephone: Number,
    coursePackageList: Object,
    formatCoursePackageList: Object,
    buytime: String,
  },
  computed: {
    ...mapGetters(["addClassHourDialog"]),
  },
  created() {},
  mounted() {
    this.form.outTelephone = this.telephone;
    this.form.outCoursePackageId = this.dialogRow.coursePackageId;
    this.form.coursePackageAndMemberId = this.dialogRow.id;
    this.getFormatCoursePackagesForCourse();
    this.getClassHourTransferRecordByTelephoneNumber();
    this.$nextTick(() => {
      this.$refs["form"].resetFields();
    });
  },
  methods: {
    getFormatCoursePackagesForCourse() {
      getFormatCoursePackagesForCourse().then((res) => {
        console.log("getFormatCoursePackagesForCourse");
        console.log(res);
        this.options = res.data.data;
      });
    },
    getClassHourTransferRecordByTelephoneNumber() {
      const para = {
        outTelephone: this.telephone,
        outCoursePackageId: this.dialogRow.coursePackageId,
      };
      console.log(para);
      getClassHourTransferRecordByTelephoneNumber(para).then((res) => {
        console.log(res);
        this.tableData = res.data.data.classHourTransferRecords;
      });
    },
    closeDialog() {
      this.$emit("getClassHourList");
      this.$emit("closeDialog");
    },
    //表单提交
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          const para = Object.assign(formData, {
            inCoursePackageId: this.form.inCoursePackageId[1],
            buytime: this.buytime,
          });
          console.log(para);
          let coursePackageName = this.formatCoursePackageList
            .formatCoursePackageList[parseInt(this.form.outCoursePackageId)];
          let outCoursePackageName = this.formatCoursePackageList
            .formatCoursePackageList[parseInt(this.form.inCoursePackageId)];
          transferClassHour(para).then((res) => {
            console.log(res);
            if (res.data.code == 200) {
              this.$message({
                message: "转让成功",
                type: "success",
              });
              const para = {
                userName: getToken("USERNAME"),
                content:
                  "转让手机号:" +
                  this.form.outTelephone +
                  "会员的课时操作" +
                  ",转让课包类型:" +
                  coursePackageName +
                  "，转让课时数:" +
                  this.form.classhours +
                  ",转出到手机号:" +
                  this.form.inTelephone +
                  "会员的课包:" +
                  outCoursePackageName,
              };
              addOperationRecord(para).then((res) => {
                console.log(res);
              });
              this.$refs["form"].resetFields();
              console.log(this.form);
              this.form = {
                outTelephone: "",
                outCoursePackageId: "",
                classhours: "",
                inTelephone: "",
                inCoursePackageId: "",
                coursePackageDDL: "",
              };
              this.getClassHourTransferRecordByTelephoneNumber();
            } else {
              this.$message({
                message: res.data.msg,
                type: "warning",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
